import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type Wishlist, wishlist } from "../schemas/wishlist";

export const addWishlistItemTagProps = z
  .object({
    tag: z.number(),
    token: z.string(),
    productId: z.string(),
    variantId: z.string().optional(),
  })
  .extend(requestConfig.shape);

export type AddWishlistItemTagProps = z.infer<typeof addWishlistItemTagProps>;

export const addWishlistItemTag = async (
  args: AddWishlistItemTagProps,
): Promise<Wishlist> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    tag: tagId,
    token,
    productId,
    variantId,
    proxyAuthSecret,
  } = parseServiceInput(addWishlistItemTagProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v3/wishlist`, {
    method: "PATCH",
    headers,
    body: JSON.stringify({ tagId, productId, variantId }),
  });

  return parseServiceOutput(response, wishlist, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
